<template>
  <div>
    <!-- Renderizar el elemento solo si tiene permiso, o siempre si hideIfNoAccess=false -->
    <template v-if="!isDisabled || !hideIfNoAccess">
      <!-- Pasar todos los slots -->
      <slot :disabled="isDisabled"></slot>
    </template>
  </div>
</template>

<script>
import PermissionService from '@/services/PermissionService';

export default {
  name: 'FieldPermissionWrapper',
  props: {
    domain: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    // Acción individual a verificar (deprecated)
    action: {
      type: String,
      default: null
    },
    // Múltiples acciones a verificar
    actions: {
      type: [String, Array],
      default: () => 'write'
    },
    // Modo de verificación: 'any' (cualquier acción) o 'all' (todas las acciones)
    mode: {
      type: String,
      default: 'any',
      validator: value => ['any', 'all'].includes(value)
    },
    hideIfNoAccess: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Determinar qué acciones verificar
     */
    actionsToCheck() {
      return this.actions || this.action || 'write';
    },
    
    /**
     * Determina si el componente debe estar deshabilitado basado en permisos
     */
    isDisabled() {
      return PermissionService.isFieldDisabled(
        this.domain,
        this.field,
        this.actionsToCheck
      );
    },
    
    /**
     * Obtiene los estados de permiso para cada acción individual
     */
    permissionStates() {
      if (typeof this.actionsToCheck === 'string') {
        return {
          [this.actionsToCheck]: !PermissionService.isFieldDisabled(this.domain, this.field, this.actionsToCheck)
        };
      }
      
      // Si es un array, devolver el estado para cada acción
      return this.actionsToCheck.reduce((acc, action) => {
        acc[action] = !PermissionService.isFieldDisabled(this.domain, this.field, action);
        return acc;
      }, {});
    }
  }
}
</script>
